<template>
  <section class="factorytests__modal">
    <div class="setting-card">
      <div class="setting-card_header">
        <span class="setting-card_header_name">
          {{ 'Test #'+data.id+'  '+get_date(data.ts) }}
        </span>
      </div>

      <div class="setting-card_content">
        <div v-for="(item, key) in get_list()" :key="key" class="setting-card_content_channels content-item" >
          <div class="left">
            <span class="title">{{key}}</span>
          </div>
          <div class="right">
            <span class="title">{{item}}</span>
          </div>
        </div>

      </div>
    </div>

    <div class="text-center">
      <button
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </section>
</template>

<script>


export default {
  name: "FactoryTestItem",
  props: ['data'],
  data () {
    return {
      load: false,
      th: [],
      tr: [],
      ifaces: [],
      result_data: {},
      speed_test_result: {},
      duration: 0,
      server: null,

      old_url: null
    }
  },
  created () {
    this.init()
    this.get_list()
  },
  destroyed(){
    this.close_modal()
  },
  methods: {
    init(){
      if (!this.$route.query.factorytest_id) {
        this.old_url = this.$route.fullPath
        history.pushState(null, null, window.location.href + '?factorytest_id=' + this.data.id)
      }
    },
    close_modal () {
      if (this.$route.query.factorytest_id) {
        let new_window = this.$route.fullPath.replace('?factorytest_id='+ this.data.id, '')
        this.$router.push(new_window)
      }else{
        this.$router.push(this.old_url)
      }
      this.$emit('close')
    },
    get_list(){
      return JSON.parse(this.data.param);
    },
  },
}
</script>

<style lang="scss" scoped>
  .factorytests__modal{
    .title{
      text-align: center;
      margin-top: 10px;
      text-transform: uppercase;
      span{
        display: block;
      }
    }
    .duration{
      text-align: center;
    }
    .setting-card {
      color: #252422;
      padding-bottom: 10px;
      position: relative;
      border: 1px solid #ccc;
      min-height: 85px;
      background-color: #f8f8f8;
      &_header {
        font: 300 14px/20px "Roboto", Arial, sans-serif;
        text-transform: uppercase;
        color: #000;
        background: #f4f3ef;
        padding: 1rem 2rem;
        border-radius: 10px 10px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &_content {
        font: 300 12px/16px "Roboto", Arial, sans-serif;
        text-align: center;
        .content-item{
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding: 5px;
          &:nth-child(2n+1) {
            background-color: #e2ecdc;
          }
          .left{
            width: 40%;
          }
          .right{
            width: 60%;
          }
          div{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 12px;
            height: 100%;
            span{
              text-overflow: ellipsis;
            }
          }
        }
      }
      &_footer {
        text-align: center;
        padding: 15px 0 5px;
        border-top: 1px solid #ccc;
      }
    }
    .text-center{
      padding-bottom: 10px;
    }
  }

  @media (max-width: 475px) {
    .setting-card {
      &_content {
        .content-item{
          flex-wrap: wrap;
          .left{
            width: 100%;
          }
          .right{
            width: 100%;
          }
        }
      }
    }
  }
</style>
